import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('uploading_your_files'),
    filesDragMessage: defineMessage('drag_drop_to_upload_as_files'),
    filesToSupplieDragMessage: defineMessage('drag_drop_to_upload_as_attachments_to_supplier'),
    uploadDisplayDefaultTitle: defineMessage('attach_file'),
    uploadDisplayOcrTitle: defineMessage('capture_or_attach_file'),
    duplicateFile: defineMessage('please_reupload_the_fil_e_name_is_already_added'),
};
